import { DateRangeModel } from './types';
import { EmptyDate } from '../date/instance';

export const EmptyDateRange = (name = ''): DateRangeModel => ({
  to: EmptyDate('to'),
  from: EmptyDate('from'),
  present: false,
  name,
});

export const EmptyDateRangeInstance = EmptyDateRange();

export const SanitizeDateRange = (dateRange: DateRangeModel | undefined | null | DeepSafePartial<DateRangeModel>): DateRangeModel | undefined | null => { // eslint-disable-line max-len
  if (!dateRange) {
    return dateRange; // handle nulls and undefined
  }
  const result: DateRangeModel = { to: EmptyDate('to'), from: EmptyDate('from'), present: false };
  result.present = dateRange.present || false;
  if (dateRange.from) {
    result.from = {
      day: dateRange.from.day || '',
      month: dateRange.from.month || '',
      year: dateRange.from.year || '',
      estimated: dateRange.from.estimated || false,
    };
    if (dateRange.from.name) {
      result.from.name = dateRange.from.name;
    }
    if (dateRange.from.$index) {
      result.from.$index = dateRange.from.$index;
    }
  }
  if (dateRange.to) {
    result.to = {
      day: dateRange.to.day || '',
      month: dateRange.to.month || '',
      year: dateRange.to.year || '',
      estimated: dateRange.to.estimated || false,
    };
    if (dateRange.to.name) {
      result.to.name = dateRange.to.name;
    }
    if (dateRange.to.$index) {
      result.to.$index = dateRange.to.$index;
    }
    if (dateRange.name) {
      result.name = dateRange.name;
    }
  }

  return result;
};
